/**
 * Constantes da Waiting List V2
 */

// Status de um paciente na lista de espera
export const PATIENT_STATUS = {
  PENDING: 'PENDING',
  CONTACTED: 'CONTACTED',
  CONFIRMED: 'CONFIRMED',
  SCHEDULED: 'SCHEDULED',
  DECLINED: 'DECLINED',
  CANCELLED: 'CANCELLED',
};

export const PATIENT_STATUS_LABELS = {
  [PATIENT_STATUS.PENDING]: 'Pendente',
  [PATIENT_STATUS.CONTACTED]: 'Contatado',
  [PATIENT_STATUS.CONFIRMED]: 'Confirmado',
  [PATIENT_STATUS.SCHEDULED]: 'Agendado',
  [PATIENT_STATUS.DECLINED]: 'Recusado',
  [PATIENT_STATUS.CANCELLED]: 'Cancelado',
};

export const PATIENT_STATUS_COLORS = {
  [PATIENT_STATUS.PENDING]: '#FF9800',
  [PATIENT_STATUS.CONTACTED]: '#2196F3',
  [PATIENT_STATUS.CONFIRMED]: '#4CAF50',
  [PATIENT_STATUS.SCHEDULED]: '#4CAF50',
  [PATIENT_STATUS.DECLINED]: '#F44336',
  [PATIENT_STATUS.CANCELLED]: '#9E9E9E',
};

// Prioridades
export const PRIORITY = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};

export const PRIORITY_LABELS = {
  [PRIORITY.HIGH]: 'Alta',
  [PRIORITY.MEDIUM]: 'Média',
  [PRIORITY.LOW]: 'Baixa',
};

export const PRIORITY_COLORS = {
  [PRIORITY.HIGH]: '#F44336',
  [PRIORITY.MEDIUM]: '#FF9800',
  [PRIORITY.LOW]: '#4CAF50',
};

// Status das ofertas de horário
export const OFFER_STATUS = {
  NOT_OFFERED: 'not_offered',
  OFFERED: 'offered',
  WAITING_RESPONSE: 'waiting_response',
  DENIED: 'denied',
  SCHEDULED: 'scheduled',
  EXPIRED: 'expired',
};

export const OFFER_STATUS_LABELS = {
  [OFFER_STATUS.NOT_OFFERED]: 'Não oferecido',
  [OFFER_STATUS.OFFERED]: 'Oferecido',
  [OFFER_STATUS.WAITING_RESPONSE]: 'Aguardando resposta',
  [OFFER_STATUS.DENIED]: 'Negado',
  [OFFER_STATUS.SCHEDULED]: 'Agendado',
  [OFFER_STATUS.EXPIRED]: 'Expirado',
};

// Tabs da página
export const TABS = {
  PATIENTS: 'patients',
  OPPORTUNITIES: 'opportunities',
};
